class Emitter {
  constructor(obj) {
    Object.assign(this, obj);

    this.listeners = [];
  }

  emit(name, ...args) {
    let listeners = this.listeners.filter(function (listener) {
      return name === listener.name;
    });

    listeners.forEach(function (listener) {
      listener.callback.apply(listener.context, args);

      if (listener.once) {
        this.off(name, listener.callback);
      }
    }, this);
  }

  on(name, callback, context, once) {
    this.listeners.push({ name, callback, context, once });
  }

  once(name, callback, context) {
    this.on(name, callback, context, true);
  }

  off(name, callback) {
    this.listeners = this.listeners.filter(function (listener) {
      if (!name || (listener.name === name && (!callback || listener.callback === callback))) {
        return false;
      }

      return true;
    });
  }
}

module.exports = Emitter;
